import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { environment } from './environment/environment';
import { provideKeycloak } from 'keycloak-angular';
import { keycloakConfig } from './auth/keycloak.config';
import { provideNzI18n, it_IT } from 'ng-zorro-antd/i18n';

import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { UserService } from './services/api/user/user.service';
import { UserService_Mock } from './services/mock/user/user.service';
import { LicenseService } from './services/api/license/license.service';
import { LicenseService_Mock } from './services/mock/license/license.service';
import { AntennaService } from './services/api/antenna/antenna.service';
import { AntennaService_Mock } from './services/mock/antenna/antenna.service';
import { BomComponentService } from './services/api/bom-component/bom-component.service';
import { BomComponentService_Mock } from './services/mock/bom-component/bom-component.service';
import { ObstacleService } from './services/api/obstacle/obstacle.service';
import { ObstacleService_Mock } from './services/mock/obstacle/obstacle.service';
import { IPDService } from './services/api/ipd/ipd.service';
import { IPDService_Mock } from './services/mock/ipd/ipd.service';
import { ChannelService } from './services/api/channel/channel.service';
import { ChannelService_Mock } from './services/mock/channel/channel.service';
import { AmplifierService } from './services/api/amplifier/amplifier.service';
import { AmplifierService_Mock } from './services/mock/amplifier/amplifier.service';
import { FloorPlanService } from './services/api/floorplan/floorplan.service';
import { FloorPlanService_Mock } from './services/mock/floorplan/floorplan.service';
import { ProjectService } from './services/api/project/project.service';
import { ProjectService_Mock } from './services/mock/project/project.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideAnimations(),
    provideNzI18n(it_IT),

    ...(environment.keycloak.enabled
      ? [
        provideKeycloak({
          config: keycloakConfig,
          initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: false
          }
        })
      ]
      : []),
    {
      provide: UserService,
      useClass: environment.useMock ? UserService_Mock : UserService
    },
    {
      provide: LicenseService,
      useClass: environment.useMock ? LicenseService_Mock : LicenseService
    },
    {
      provide: AntennaService,
      useClass:environment.useMock ? AntennaService_Mock : AntennaService
    },    
    {
      provide: BomComponentService,
      useClass: environment.useMock ? BomComponentService_Mock : BomComponentService
    },
    {
      provide: ObstacleService,
      useClass: environment.useMock ? ObstacleService_Mock : ObstacleService
    },
    {
      provide: IPDService,
      useClass: environment.useMock ? IPDService_Mock : IPDService
    },
    {
      provide: ChannelService,
      useClass: environment.useMock ? ChannelService_Mock : ChannelService
    },
    {
      provide: AmplifierService,
      useClass: environment.useMock ? AmplifierService_Mock : AmplifierService
    },
    {
      provide: FloorPlanService,
      useClass: environment.useMock ? FloorPlanService_Mock : FloorPlanService
    },
    {
      provide: ProjectService,
      useClass: environment.useMock ? ProjectService_Mock : ProjectService
    }
  ]
};
registerLocaleData(localeIt);
